export default {
  methods: {
    getStarsValueText: function (kpi) {
      return this.getStarsValue(kpi).toFixed(1);
    },
    getStarsValue: function (kpi) {
      return this.getStarsValue(kpi, NaN);
    },
    getStarsValue: function (kpi, defaultReturn) {
      if (kpi && kpi.YTD) {
        const val = _.findLast(kpi.YTD);
        if (val) {
          return ((val.PointsReached / val.PointsMax) * 5).toFixed(1) ;
        }
      }
      return "n/a";
    },
    getStarsValueCalulationText: function (items, defaultReturn) {
      let result = this.getStarsValueCalulation(items, defaultReturn);
      if (result === defaultReturn) {
        return result;
      }
      return result;
    },
    getStarsValueCalulation: function (items, defaultReturn) {
      // Caclulation must be done over PointsReached / PointsMax!!!
      try {
        let data = [ { reached: 0, max: 0 }, { reached: 0, max: 0 }, { reached: 0, max: 0 } ];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item && item.YTD) {
            const val = _.findLast(item.YTD);
            data[i].reached = val.PointsReached;
            data[i].max = val.PointsMax;
          } else {
            data[i] = { reached: 0, max: 0};
          }
        }

        let reached = 0;
        let max = 0;
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          reached += item.reached;
          max += item.max;
        }

        if (max !== 0) {
          return ((reached / max) * 5).toFixed(1);
        }
        return defaultReturn;
      } catch (error) {
        return defaultReturn;
      }
    },
  }
};
